<template>
  <div id="overview">
    <div class="overview-container">
      <div class="filter-bar">
        <el-form :inline="true" :model="queryParams" class="search-form b-mt-20" label-width="106px">
          <el-form-item label="医疗机构名称:">
            <el-select v-model="queryParams.orgCode" placeholder="请选择医疗机构名称">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(item, index) in orgList" :key="'org' + index" :label="item.orgName"
                :value="item.orgCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备品目:">
            <el-select v-model="queryParams.item" placeholder="请选择设备品目">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(item, index) in itemList" :key="'item' + index" :label="item.item"
                :value="item.item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="queryAll">查询</el-button>
        <el-button type="info" @click="resetQuery">重置</el-button>
      </div>
      <!-- 顶部统计栏 -->
      <div class="top-stats-grid" style="height: 120px;">
        <div class="data-card">
          <div class="card-title">总设备数</div>
          <div class="card-value">{{ totalDeviceCount }}</div>
        </div>
        <div class="data-card">
          <div class="card-title">设备有效总时长（分钟）</div>
          <div class="card-value">{{ effectiveCount }}</div>
        </div>
        <div class="data-card">
          <div class="card-title">设备扫描总次数</div>
          <div class="card-value">{{ checkCount }}</div>
        </div>
      </div>

      <!-- 中间内容区 -->
      <div class="middle-content-grid">
        <!-- 有效时长TOP5 -->
        <div class="content-card">
          <div style="display: flex; justify-content: space-between;">
            <div class="text-sm font-medium mb-2">有效时长TOP5</div>
            <div class="text-sm font-medium mb-2">单位：分钟</div>
          </div>
          <div class="benefit-list">
            <div class="benefit-item" v-for="(item, index) in effectiveTop5List" :key="'item' + index">
              <el-tooltip :content="item.label" placement="right">
                <div class="benefit-name">{{ item.label }}</div>
              </el-tooltip>
              <div class="benefit-bar-container">
                <div class="benefit-bar" :style="{ width: item.percent + '%', backgroundColor: barColors[index] }"></div>
              </div>
            </div>
          </div>
          <div class="benefit-scale">
            <span v-for="(item, index) in effectiveTop5TitleList" :key="'item' + index">{{ item.count }}</span>
          </div>
        </div>
        <!-- 扫描次数TOP5 -->
        <div class="content-card">
          <div style="display: flex; justify-content: space-between;">
            <div class="text-sm font-medium mb-2">扫描次数TOP5</div>
            <div class="text-sm font-medium mb-2">单位：次</div>
          </div>
          <div class="benefit-list">
            <div class="benefit-item" v-for="(item, index) in checkTop5List" :key="'item' + index">
              <el-tooltip :content="item.label" placement="right">
                <div class="benefit-name">{{ item.label }}</div>
              </el-tooltip>
              <div class="benefit-bar-container">
                <div class="benefit-bar" :style="{ width: item.percent + '%', backgroundColor: barColors[index] }"></div>
              </div>
            </div>
          </div>
          <div class="benefit-scale">
            <span v-for="(item, index) in checkTop5TitleList" :key="'item' + index">{{ item.count }}</span>
          </div>
        </div>
      </div>

      <!-- 底部内容区 -->
      <div class="bottom-content-grid">
        <div class="content-card">
          <div style="display: flex; justify-content: space-between;">
            <div class="text-sm font-medium mb-2">设备预算金额与合同签订金额偏差分析</div>
            <div class="text-sm font-medium mb-2">单位：万元</div>
          </div>
          <div class="mt-2">
            <!-- 设备预算金额与合同签订金额偏差分析 -->
            <div class="chart-container">
              <div id="investmentChart" class="echarts-chart"></div>
            </div>
            <!-- 设备维护成本 -->
            <div class="text-xs font-medium text-gray-600 mt-4 mb-2">设备维护成本 (万元)</div>
            <div class="chart-container">
              <div id="costChart" class="echarts-chart"></div>
            </div>
          </div>
        </div>

        <div class="content-card">
          <!-- 设备效益分析 -->
          <div class="text-sm font-medium mb-2">设备效益分析</div>
          <div style="display: flex; justify-content: space-between;">
            <div class="text-xs font-medium text-gray-600 mb-2">扫描次数/品目</div>
            <div class="text-xs font-medium text-gray-600 mb-2">单位：次</div>
          </div>
          <div class="mt-2">
            <div class="chart-container">
              <div id="equipmentUsageChart" class="echarts-chart"></div>
            </div>
            <!-- 设备品目分类数据分析 -->
            <div class="text-xs font-medium text-gray-600 mt-4 mb-2">设备品牌分类数据分析</div>
            <div class="chart-container">
              <div id="deviceItemChart" class="echarts-chart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { totalDeviceCount, effectiveCount, checkCount, queryYsHtMoneyList, queryItemsList, queryOrgList, effectiveTop5, checkTop5, maintenanceList, equipmentUsageList, deviceItemList } from '@/api/modules/dataView'
// 不再需要直接导入echarts，使用main.js中挂载的this.$echarts
export default {
  name: 'Overview',
  data() {
    return {
      // 组件数据
      totalDeviceCount: 0,
      effectiveCount: 0,
      checkCount: 0,
      ysHtMoneyList: [],
      yyList: [],
      ysMoneyList: [],
      htMoneyList: [],
      investmentChart: null,
      costChart: null,
      equipmentUsageChart: null,
      deviceItemChart: null,
      orgList: [],
      itemList: [],
      queryParams: {
        orgCode: '',
        item: '',
      },
      effectiveTop5List: [],
      checkTop5List: [],
      maintenanceList: [],
      maintenanceTitle: [],
      maintenanceCost: [],
      effectiveTop5TitleList: [],
      checkTop5TitleList: [],
      barColors: ['#409eff', '#6777ef', '#a655f1', '#40c057', '#f79009'],
      equipmentUsageList: [],
      equipmentUsageTitle: [],
      equipmentUsageCount: [],
      deviceItemList: []
    }
  },
  mounted() {
    this.queryTotalDeviceCount()
    this.queryEffectiveCount()
    this.queryCheckCount()
    this.queryYsHtMoney()
    this.queryItems()
    this.queryOrg()
    this.queryEffectiveTop5()
    this.queryCheckTop5()
    this.queryMaintenanceList()
    this.queryEquipmentUsage()
    this.queryDeviceItemList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.investmentChart) {
      this.investmentChart.dispose();
    }
    if (this.costChart) {
      this.costChart.dispose();
    }
    if (this.equipmentUsageChart) {
      this.equipmentUsageChart.dispose();
    }
    if (this.deviceItemChart) {
      this.deviceItemChart.dispose();
    }
  },
  methods: {
    initInvestmentChart() {
      // 设备投入趋势图（折线图）
      this.investmentChart = this.$echarts.init(document.getElementById('investmentChart'));
      const investmentOption = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['采购金额', '预算金额'],
          top: 0,
          textStyle: {
            fontSize: 10
          },
          itemWidth: 13
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.yyList,
          axisLabel: {
            rotate: 45,
            fontSize: 10
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          min: 5,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        },
        series: [
          {
            name: '采购金额',
            type: 'line',
            data: this.htMoneyList,
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: {
              color: '#409eff'
            },
            itemStyle: {
              color: '#409eff',
              borderColor: '#fff',
              borderWidth: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(64, 158, 255, 0.3)'
                }, {
                  offset: 1, color: 'rgba(64, 158, 255, 0.05)'
                }]
              }
            }
          },
          {
            name: '预算金额',
            type: 'line',
            data: this.ysMoneyList,
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: {
              color: '#f79009'
            },
            itemStyle: {
              color: '#f79009',
              borderColor: '#fff',
              borderWidth: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(247, 144, 9, 0.3)'
                }, {
                  offset: 1, color: 'rgba(247, 144, 9, 0.05)'
                }]
              }
            }
          }
        ]
      };
      this.investmentChart.setOption(investmentOption);
    },
    initCostChart() {
      // 维护成本柱状图
      this.costChart = this.$echarts.init(document.getElementById('costChart'));
      const costOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: [],
          right: '3%',
          top: '10%',
          textStyle: {
            fontSize: 10,
            color: '#606266'
          },
          itemWidth: 12
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.maintenanceTitle,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#606266'
            }
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#606266'
            }
          },
          axisLabel: {
            rotate: 45,
            color: '#606266'
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#606266'
            }
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#606266'
            }
          },
          axisLabel: {
            color: '#606266'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        },
        series: [
          {
            name: '日常维护',
            type: 'bar',
            data: this.maintenanceCost,
            itemStyle: {
              color: '#40c057'
            },
            barWidth: '25%',
            label: {
              show: true,
              position: 'top',
              fontSize: 10,
              color: '#606266'
            }
          }
        ]
      };
      this.costChart.setOption(costOption);
    },
    initEquipmentUsageChart() {
      // 设备使用频次柱状图
      this.equipmentUsageChart = this.$echarts.init(document.getElementById('equipmentUsageChart'));
      const equipmentUsageOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.equipmentUsageTitle,
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            rotate: 45
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        },
        series: [
          {
            name: '使用频次',
            type: 'bar',
            data: this.equipmentUsageCount,
            itemStyle: {
              color: function (params) {
                const colors = [
                  'rgba(64, 158, 255, 1)'
                ];
                return colors[0];
              }
            },
            barWidth: '60%',
            label: {
              show: true,
              position: 'top',
              fontSize: 10,
              color: '#606266'
            }
          }
        ]
      };
      this.equipmentUsageChart.setOption(equipmentUsageOption);
    },
    initDeviceItemChart() {
      this.deviceItemChart = this.$echarts.init(document.getElementById('deviceItemChart'));
      const deviceItemOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.deviceItemList.map(item => item.name),
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            rotate: 45
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        },
        series: [
          {
            name: '设备品目分类数据分析',
            type: 'bar',
            data: this.deviceItemList.map(item => item.count),
            itemStyle: {
              color: '#40c057'
            },
            barWidth: '60%',
            label: {
              show: true,
              position: 'top',
              fontSize: 10,
              color: '#606266'
            }
          }
        ]
      };
      this.deviceItemChart.setOption(deviceItemOption);
    },
    handleResize() {
      if (this.investmentChart) {
        this.investmentChart.resize();
      }
      if (this.costChart) {
        this.costChart.resize();
      }
      if (this.equipmentUsageChart) {
        this.equipmentUsageChart.resize();
      }
      if (this.deviceItemChart) {
        this.deviceItemChart.resize();
      }
    },
    queryEffectiveTop5() {
      effectiveTop5(this.queryParams).then(res => {
        const maxCount = Math.max(...res.map(item => item.count))
        this.effectiveTop5List = res.map(item => ({
          ...item,
          percent: maxCount > 0 ? (item.count / maxCount * 100).toFixed(1) : 0
        }))
        let ress = res
        this.effectiveTop5TitleList = ress.reverse()
      })
    },
    queryCheckTop5() {
      checkTop5(this.queryParams).then(res => {
        const maxCount = Math.max(...res.map(item => item.count))
        this.checkTop5List = res.map(item => ({
          ...item,
          percent: maxCount > 0 ? (item.count / maxCount * 100).toFixed(1) : 0
        }))
        let ress = res
        this.checkTop5TitleList = ress.reverse()
      })
    },
    queryTotalDeviceCount() {
      totalDeviceCount(this.queryParams).then(res => {
        this.totalDeviceCount = res
      })
    },
    queryEffectiveCount() {
      effectiveCount(this.queryParams).then(res => {
        this.effectiveCount = res
      })
    },
    queryCheckCount() {
      checkCount(this.queryParams).then(res => {
        this.checkCount = res
      })
    },
    queryYsHtMoney() {
      queryYsHtMoneyList(this.queryParams).then(res => {
        this.ysHtMoneyList = res
        this.$nextTick(() => {
          this.yyList = res.map(item => item.orgName)
          this.ysMoneyList = res.map(item => item.ysMoney)
          this.htMoneyList = res.map(item => item.htMoney)
          this.initInvestmentChart()
        })
      })
    },
    queryMaintenanceList() {
      maintenanceList(this.queryParams).then(res => {
        this.maintenanceList = res
        this.$nextTick(() => {
          this.maintenanceTitle = res.map(item => item.orgName)
          this.maintenanceCost = res.map(item => item.count)
          this.initCostChart()
        })
      })
    },
    queryEquipmentUsage() {
      equipmentUsageList(this.queryParams).then(res => {
        this.equipmentUsageList = res
        this.$nextTick(() => {
          this.equipmentUsageTitle = res.map(item => item.device)
          this.equipmentUsageCount = res.map(item => item.count)
          this.initEquipmentUsageChart()
        })
      })
    },
    queryDeviceItemList() {
      deviceItemList(this.queryParams).then(res => {
        this.deviceItemList = res
        this.$nextTick(() => {
          this.initDeviceItemChart()
        })
      })
    },
    queryItems() {
      queryItemsList().then(res => {
        this.itemList = res
      })
    },
    queryOrg() {
      queryOrgList().then(res => {
        this.orgList = res
      })
    },
    queryAll() {
      this.queryYsHtMoney()
      this.queryMaintenanceList()
      this.queryEquipmentUsage()
      this.queryEffectiveTop5()
      this.queryCheckTop5()
      this.queryCheckCount()
      this.queryTotalDeviceCount()
      this.queryEffectiveCount()
      this.queryDeviceItemList()
    },
    resetQuery() {
      this.queryParams = {
        orgCode: '',
        item: '',
      }
      this.queryAll() 
    }
  }
}
</script>

<style lang="scss" scoped>
#overview {
  width: 100%;
  padding: 20px;
  background-color: #f5f7fa;
  height: 100%;
  min-height: 100vh;
}

.overview-container {
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
}

.top-stats-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stats-card {
  background-color: white;
  border-radius: 6px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #ebecf3;
  color: #000;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }
}

.stats-content {
  margin-top: 8px;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 6px;
  color: #606266;
}

.progress-container {
  display: flex;
  align-items: center;
  row-gap: 50%;
  column-gap: 2%;
}

.progress-bar-bg {
  height: 6px;
  border-radius: 3px;
  background-color: #f0f2f5;
  width: 100%;
}

.progress-bar-fill {
  height: 6px;
  border-radius: 3px;
  background-color: #409eff;
}

.chart-container {
  margin-top: 20px;
  height: 300px;
}

.stats-card .chart-container.chart-center {
  margin-top: 10px;
}

.stats-card .text-sm {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
}

.chart-center {
  display: flex;
  justify-content: center;
}

.middle-content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.bottom-content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.content-card {
  background-color: white;
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #ebecf3;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}

.content-card .text-sm {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 1px;
}

.benefit-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 15px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.benefit-name {
  width: 10ch;
  font-size: 13px;
  color: #606266;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 10ch;
}

.benefit-bar-container {
  background-color: #f0f2f5;
  flex: 1;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
}

.benefit-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.benefit-scale {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #909399;
  margin-top: 15px;
  padding: 0 15px;
}

.safety-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  text-align: center;
  padding: 20px 0;
}

.safety-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
}

.safety-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  font-size: 24px;
}

.safety-icon-blue {
  background-color: rgba(37, 99, 235, 0.1);
  color: #2563eb;
}

.safety-icon-red {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.safety-value {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.safety-label {
  font-size: 12px;
  color: #909399;
}

.echarts-chart {
  width: 100%;
  height: 300px;
}

#purchaseRateChart {
  width: 180px;
  height: 180px;
}

#equipmentStatusChart {
  width: 100px;
  height: 100px;
}

.text-gray-500 {
  color: #909399;
}

.text-green-600 {
  color: #67c23a;
}

.text-orange-500 {
  color: #e6a23c;
}

.text-red-500 {
  color: #f56c6c;
}

.text-blue-500 {
  color: #409eff;
}

.text-purple-600 {
  color: #909399;
}

.text-teal-600 {
  color: #67c23a;
}

.text-amber-600 {
  color: #e6a23c;
}

.font-medium {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
}

.text-m {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  text-align: center;
  margin-top: 12px;
}

.w-1 {
  width: 50%;
}

.ml-1 {
  margin-left: 10px;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.data-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #ebecf3;
  min-height: 100px;
}

.data-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

/* 卡片标题样式 */
.card-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 15px;
  font-weight: 500;
}

/* 卡片数值样式 */
.card-value {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

/* 卡片单位样式 */
.card-unit {
  font-size: 12px;
  color: #909399;
  margin-bottom: 10px;
}

/* 卡片变化样式 */
.card-change {
  font-size: 12px;
  font-weight: 500;
}

.positive {
  color: #67c23a;
}

.negative {
  color: #f56c6c;
}
</style>